import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone, generateCircleDot } from '../utils'
import Loading from './Loading'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';

function DomainAuthority({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()


    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'da',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(data=> {
                setData(data)
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }

    const toggleInfo = () => {
        setShowInfo(!showInfo);
    };




  return (
    <DomainAuthorityContainer>
            <DomainAuthorityInputContainer>
            <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>
                Domain Authority
                {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--bl-color)'}}/> : <AddIcon style={{color: 'var(--bl-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
Domain Authority is a metric that predicts a website's ranking potential on search engine result pages (SERPs) based on various factors. It's important as it helps gauge a website's overall SEO performance and competitiveness in search rankings.</HeaderSpan>
            )}</div>
            <DomainAuthorityInnerInputContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </DomainAuthorityInnerInputContainer>
        </DomainAuthorityInputContainer>

        {data.length !== 0 && !isLoading && <DomainAuthorityResContainer>
            <DomainAuthorityRes style={{fontWeight: '400', fontSize: 'small'}}>
                <h2>{data[0]?.score} <span>out of 100</span></h2>
                <h5>Domain Authority</h5>
            </DomainAuthorityRes>
        </DomainAuthorityResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Domain Authority Tool measures the overall strength and credibility of your domain. 
            It provides a score based on various factors, including backlinks, content quality, and site structure, indicating how likely your entire domain is to rank in search engine results.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of your domain</p>
          <p>2. Click "Get Data" to view the authority score and detailed insights</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Boost your domain authority by building high-quality backlinks, improving your site’s content, and ensuring a good user experience</p>

        </Intro>}
    </DomainAuthorityContainer>
  )
}

export default DomainAuthority


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const DomainAuthorityContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const DomainAuthorityInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--bl-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--bl-color);
    color: white;
  }

  > div > button:hover {
    color: var(--bl-color);
    background-color: rgb(239, 239, 239);
  }
`


const DomainAuthorityInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const DomainAuthorityResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const DomainAuthorityRes = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin-block: 5px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    > h2 {
        font-size: 30px;
    }

    > h2 > span {
        font-size: small;
        color: gray;
        font-weight: 400;
    }

    > h5 {
        font-size: small;
        font-weight: 500;
    }
`

const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--bl-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`